import { createContext } from 'react';
import { GatsbyContextProps } from './GatsbyInterface';

export const GatsbyContext =
  createContext<GatsbyContextProps | undefined>(undefined);
